/*************************************************************************************************
 * THESE ARE CONTROLLERS FOR ALL Rates And Regulations Pages
 ************************************************************************************************/

var _getServlet = function() {
  return window.location.pathname.indexOf('/cs/')===0 ? '/cs' : '/ss';
};

var common = common || {};
common.thisYear = new Date().getFullYear();

var getYears = function (endYear) {
  var years = [];
  var startYear = common.thisYear;
  while (startYear>=endYear) {
    years.push(startYear--);
  }
  return years;
};
common.statementYears = common.revisionYears = getYears(2002);

angular.module('app.controllers.rates_and_tariffs', ['ngLodash'])

  .controller("ArizonaRatesLandingController", function ($scope, $log, $timeout, lodash, SearchService) {
    // Historical Statements year selection
    $scope.statementYears = common.statementYears;
    $scope.revisionYears = common.revisionYears;

    $scope.getHistoricalStatements = function (year) {
      var it = 'HistoricalStatements';
      $scope[it] = {};
      lodash.assign($scope[it], {
        'data': {},
        'year': year,
        'options': { 'q_State': 'AZ', 'fq': 'EffectiveDate:date:' + year + '-0', 'q_Type': 'StatementOfRate', 'max': 100 }
      });

      SearchService.findRate($scope[it].options, $scope[it].data);
    };

    $scope.getTariffRevisions = function (year) {
      var it = 'TariffRevisions';
      $scope[it] = {};
      lodash.assign($scope[it], {
        'data': {},
        'year': year,
        'options': { 'q_State': 'AZ', 'fq': 'EffectiveDate:date:' + year + '-0', 'q_Type': 'Tariff' }
      });

      SearchService.findRate($scope[it].options, $scope[it].data);
    };

    $timeout(function() {
      // 'AZ Top Links' is not needed, was manually done. May revisit this.
      ['AZ Gas Tariff 7', 'AZ Statement of Rates', 'AZ Rate Schedules', 'AZ Special Supplementary Tariff', 
        'AZ Rules', 'AZ Tariff Revisions', 'AZ General Rate Case Filings' ].forEach(function(it) {
        var name =  it.slice(3).replace(/\s+/g, '');
        $scope[name] = {};
        lodash.assign($scope[name], {
          'data': {},
          'options': { 'q_FolderName': "'" + it + "'" }
        });
        SearchService.findPDF($scope[name].options, $scope[name].data);
      });
      $scope.getHistoricalStatements(common.thisYear);
      $scope.getTariffRevisions(common.thisYear);
    });
  })

/********************************************************* Controller California Rates and Regulation landing page  *****/
  .controller("CaliforniaRatesLandingController", function ($scope, $log, $filter, $timeout, lodash, SearchService) {
    $scope.statementYears = common.statementYears;
	$scope.IsVisible = false;
	$scope.status = {
    isopen: false
  };

	 $scope.setVisibile = function() {
			$scope.IsVisible = false;
      $scope.myCount++;
	};
    $scope.getCaseFilings = function(filing) {
    $scope.status.isopen = !$scope.status.isopen;
    var it = 'GeneralRateCaseFilings';
      $scope[it].selected = filing;
      lodash.assign($scope[it], {
        'data': {},
        'options': { 'q_FolderName': "'" + filing + "'" }
      });
      SearchService.findPDF($scope[it].options, $scope[it].data);
    };

    $scope.getHistoricalStatements = function (year) {
    $scope.status.isopen1 = !$scope.status.isopen1;
      var it = 'HistoricalStatements';
      $scope[it] = {};
      lodash.assign($scope[it], {
        'data': {},
        'year': year,
        'options': { 'q_State': 'CA', 'fq': 'EffectiveDate:date:' + year + '-0', 'q_Type': 'StatementOfRate', 'sort': 'EffectiveDate:true', 'max': 100 }
      });

      SearchService.findRate($scope[it].options, $scope[it].data).then(function(){
        $scope[it].availableDates = [];
        $scope[it].itemsByDateAndState = {};
        $scope[it].data.items.forEach(function(doc) {
          if (!doc.ratedivision) {
            return;
          }
          var dateStr = $filter('date')(doc.effectivedate, 'mediumDate', 'PDT');
          if ($scope[it].availableDates.indexOf(dateStr) === -1) {
            $scope[it].availableDates.push(dateStr);
            $scope[it].itemsByDateAndState[dateStr] = { 'SouthernCalifornia': [], 'NorthernCalifornia': [], 'SouthLakeTahoe': [] };
          }
          $scope[it].itemsByDateAndState[dateStr][doc.ratedivision].push(doc);
        });
      });
    };

    $timeout(function() {
      ['CA Gas Tariff', 'CA Statement of Rates', 'CA Rate Schedules', 'CA Special Supplementary Tariff', 
        'CA Rules', 'CA Sample Forms', 'CA General Rate Case Filings'].forEach(function(it) {
        var name =  it.slice(3).replace(/\s+/g, '');
        $scope[name] = {};
        lodash.assign($scope[name], {
          'data': {},
          'options': { 'q_FolderName': "'" + it + "'" }
        });
        SearchService.findPDF($scope[name].options, $scope[name].data);
      });

      $scope.GeneralRateCaseFilings = { 'filings' : ['Application No. 07-12-022','Application No. 12-12-024'], 'selected': 'Application No. 07-12-022' };
      $scope.getHistoricalStatements(common.thisYear);
      $scope.getCaseFilings($scope.GeneralRateCaseFilings.selected);
    });
  })

/********************************************************* Controller Nevada Rates and Regulation landing page  *****/
  .controller("NevadaRatesLandingController", function ($scope, $log, $filter, $timeout, lodash, SearchService) {

    // Historical Statements year selection
    $scope.statementYears = common.statementYears;
    $scope.revisionYears = common.revisionYears;

    $scope.getServiceMaps = function(region) {
      var it = 'ServiceMaps';
      $scope[it].selected = region;
      lodash.assign($scope[it], {
        'data': {},
        'options': { 'q_FolderName': "'" + region + "'" }
      });
      SearchService.findPDF($scope[it].options, $scope[it].data);
    };

    $scope.getHistoricalStatements = function (year) {
      var it = 'HistoricalStatements';
      $scope[it] = {};
      lodash.assign($scope[it], {
        'data': {},
        'year': year,
        'options': { 'q_State': 'NV', 'fq': 'EffectiveDate:date:' + year + '-0', 'q_Type': 'StatementOfRate', 'sort': 'EffectiveDate:true', 'max': 100 }
      });

      SearchService.findRate($scope[it].options, $scope[it].data).then(function(){
        $scope[it].availableDates = [];
        $scope[it].itemsByDateAndState = {};
        $scope[it].data.items.forEach(function(doc) {
          if (!doc.ratedivision) {
            return;
          }
          var dateStr = $filter('date')(doc.effectivedate, 'mediumDate', 'PDT');
          if ($scope[it].availableDates.indexOf(dateStr) === -1) {
            $scope[it].availableDates.push(dateStr);
            $scope[it].itemsByDateAndState[dateStr] = { 'SouthernNevada': [], 'NorthernNevada': [] };
          }
          $scope[it].itemsByDateAndState[dateStr][doc.ratedivision].push(doc);
        });
      });
    };

    $timeout(function() {
      ['NV Gas Tariff 7', 'NV Statement of Rates', 'NV Rate Schedules', 'NV Special Supplementary Tariff', 
        'NV Rules', 'NV Tariff Revisions', 'NV Service Area Maps and Description of Service Area'].forEach(function(it) {
        var name =  it.slice(3).replace(/\s+/g, '');
        $scope[name] = {};
        lodash.assign($scope[name], {
          'data': {},
          'options': { 'q_FolderName': "'" + it + "'" }
        });
        SearchService.findPDF($scope[name].options, $scope[name].data);
      });
      $scope.ServiceMaps = { 'maps' : ['Northern Nevada Division', 'Southern Nevada Division'], 'selected': 'Northern Nevada Division' };
      $scope.getHistoricalStatements(common.thisYear);
      $scope.getServiceMaps($scope.ServiceMaps.selected);
    });
  })

  .controller("CaliforniaAdviceLettersController", function ($scope, $log, $timeout, lodash, SearchService) {
    $timeout(function() {
      ['pending', 'approved', 'effectivePendingDisposition', 'rejected', 'withdrawn'].forEach(function(it) {
        $scope[it] = {};
        lodash.assign($scope[it], {
          'data': {},
          'options': { 'q_State': 'CA', 'q_Status': it.charAt(0).toUpperCase() + it.slice(1), 'q_Type': 'AdviceLetter' }
        });

        $scope.loadMore = function(type) {
          type.options.append = true;
          type.options.start += type.options.max;
          SearchService.findRate(type.options, type.data);
        };

        SearchService.findRate($scope[it].options, $scope[it].data);
      });
    });
  })

  .controller("NevadaAdviceLettersController", function ($scope, $log, $timeout, lodash, SearchService) {
    $timeout(function() {
      ['pending', 'approved', 'rejected', 'withdrawn'].forEach(function(it) {
        $scope[it] = {};
        lodash.assign($scope[it], {
          'data': {},
          'options': { 'q_State': 'NV', 'q_Status': it.charAt(0).toUpperCase() + it.slice(1), 'q_Type': 'AdviceLetter' }
        });

        $scope.loadMore = function(type) {
          type.options.append = true;
          type.options.start += type.options.max;
          SearchService.findRate(type.options, type.data);
        };

        SearchService.findRate($scope[it].options, $scope[it].data);
      });
    });
  })

;